import { Component } from '@angular/core';

@Component({
  selector: 'mtm-notification-settings-icon',
  templateUrl: './mtm-notification-settings-icon.component.html',
  standalone: true,
})
export class MtmNotificationSettingsIconComponent {}
